export const DOCUMENTS_ENDPOINTS = {
    pdf: '/documents/pdf',
};
